// The bar docked above the composer while cards wait on the athlete (Sam,
// 2026-10-29: Accept / Not now "get lost up the chat"). The cards themselves
// sit in the Needs-you block at the bottom of the thread, just above it; the
// bar shows only while that block is scrolled out of view (`inView`, from an
// IntersectionObserver in CoachThread). "Waiting for you · <title> · Review ↓"
// for one card, "<n> things waiting for you · Review ↓" for several; Review
// scrolls down to the first and highlights it. `nudge` changes when a new card
// arrived off screen: the bar pulses once (not with reduced motion). It stays
// mounted while hidden so an old nudge doesn't pulse again.
import React, { useEffect, useState } from 'react';
import { ArrowDown } from 'lucide-react';
import { cn } from '../../lib/utils';
import { HIGHLIGHT_MS, waitingBar } from '../../v2/threadView';

export default function WaitingBar({ waiting, onReview, wide = false, nudge = 0, inView = false }) {
  const [pulsing, setPulsing] = useState(false);
  useEffect(() => {
    if (!nudge) return undefined;
    setPulsing(true);
    const t = setTimeout(() => setPulsing(false), HIGHLIGHT_MS);
    return () => clearTimeout(t);
  }, [nudge]);
  const bar = waitingBar(waiting);
  if (!bar || inView) return null;
  return (
    <div className={cn('shrink-0 px-4 pt-2', wide ? 'mx-auto w-full max-w-[808px]' : 'bg-bg-panel')} aria-live="polite">
      <button type="button" onClick={onReview} aria-label={bar.label} data-testid="waiting-bar"
        className={cn('flex w-full min-w-0 items-center gap-2 rounded-chip border border-accent-tint-border bg-accent-tint px-3 py-2 text-left transition-colors hover:border-accent-default',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-default',
          pulsing && 'motion-safe:animate-pulse')}>
        <span className="h-2 w-2 shrink-0 rounded-full bg-accent-default" aria-hidden="true" />
        <span className="shrink-0 type-label text-accent-default">{bar.lead}</span>
        {bar.title && (<>
          <span className="shrink-0 type-caption text-text-tertiary" aria-hidden="true">·</span>
          <span className="min-w-0 flex-1 truncate type-body-small text-text-primary">{bar.title}</span>
        </>)}
        {!bar.title && <span className="flex-1" />}
        <span className="flex shrink-0 items-center gap-0.5 type-label text-accent-default" data-testid="waiting-bar-review">
          Review <ArrowDown size={13} aria-hidden="true" />
        </span>
      </button>
    </div>
  );
}
